import React, { useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import OverviewPage from './OverviewPage';
import DatabasePage from './DatabasePage';
import MetricsPage from './MetricsPage';
import AlertsPage from './AlertsPage';
import SettingsPage from './SettingsPage';
import './Dashboard.css';

const Dashboard: React.FC = () => {
  const [activePage, setActivePage] = useState('overview');
  const [selectedTimeRange, setSelectedTimeRange] = useState('Last 1h');

  const handleTimeRangeChange = (timeRange: string) => {
    setSelectedTimeRange(timeRange);
    console.log('Dashboard received time range change:', timeRange);
  };

  const renderMainContent = () => {
    switch (activePage) {
      case 'database':
        return <DatabasePage />;
      case 'metrics':
        return <MetricsPage timeRange={selectedTimeRange} />;
      case 'alerts':
        return <AlertsPage initialTimeRange={selectedTimeRange} />;
      case 'settings':
        return <SettingsPage />;
      case 'overview':
      default:
        return <OverviewPage onNavigate={setActivePage} />;
    }
  };

  return (
    <div className="dashboard">
      <Header 
        onTimeRangeChange={handleTimeRangeChange} 
        onNavigate={setActivePage}
      />
      <div className="dashboard-content">
        <Sidebar activeItem={activePage} onItemClick={setActivePage} />
        <main className="dashboard-main">
          {renderMainContent()}
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
